import Button from "../../../../../publicComponent/Button";
import {useOrderReserveAdd} from "../../../../../api/orderReserve";
import {useBookingDetailContext} from "../../index";
import {useNavigate} from "react-router";
import {useTranslation} from "react-i18next";
import useRequestTokenAuth from "../../../../../hooks/useRequestTokenAuth";

export default function AddBookingButton({ className }) {
  const { loading, addHandle } = useOrderReserveAdd();
  const { state } = useBookingDetailContext();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [auth] = useRequestTokenAuth();
  
  /**
   * 提交预约
   * @returns {Promise<void>}
   */
  const submit = async () => {
    await auth();
    
    let { data } = await addHandle(state.query);
    if (data) {
      navigate('/myBooking');
    }
  };
  
  return (
    <Button onClick={submit}
            loading={loading}
            className={className}>
      {t('确定预约')}
    </Button>
  );
}
